import { ProductVariation } from '@typings/product';
import classNames from 'classnames';
import useTranslation from '@components/Translation/useTranslation';
import Product from '@models/product';
import GrillCard from './_GrillCard';

interface Props {
  sizes: Array<ProductVariation>;
  activeSize: string;
  product: Product;
  dark?: boolean;
}

const AlternateSizes = ({ sizes, activeSize, product, dark = false }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="tw-grid tw-gap-4 tw-mb-6">
      <h4 className={classNames('tra-text-web-utl-link', dark && 'tw-text-white')}>
        01 - {t('productDetailPageContent.selectSizeText', undefined, { default: 'Select a Size' })}
      </h4>
      <p className="sr-only">
        {sizes.length}{' '}
        {t('productDetailPageContent.sizesAvailableText', undefined, {
          default: 'sizes available',
        })}
        ,{' '}
        {t('productDetailPageContent.selectedOptionText', undefined, {
          default: 'selected option is',
        })}{' '}
        {product?.title}
      </p>
      <ul className="tw-p-0 tw-grid tw-grid-rows-2 tw-gap-4 tw-list-none">
        {sizes?.map((variation) => (
          <GrillCard
            key={variation?.title}
            variation={variation}
            selected={variation.attributesMap.grill_size === activeSize}
          />
        ))}
      </ul>
    </div>
  );
};

export default AlternateSizes;
